<template>
  <CartInfoCard
    :infoValue="value"
    :text="text"
    :hideEdit="true"
    icon="$editcalendar"
    :editable="editable"
    :isCheckout="isCheckout"
    @edit="edit"
  />
</template>
<script>
import CartInfoCard from "./CartInfoCard";
export default {
  name: "CartInfoTimeslotCard",
  props: {
    shippingAddress: { type: Object, required: true },
    timeslot: { type: Object, required: true },
    editable: { type: Boolean, default: false },
    isCheckout: { type: Boolean, default: false }
  },
  components: { CartInfoCard },
  computed: {
    value() {
      if (this.timeslot && !this.timeslot.autoAssigned) {
        let date = this.$dayjs(this.timeslot.date);
        return (
          date.format("D MMMM") +
          " | " +
          this.$dayjs(this.timeslot.beginTime, ["h:mm:ss A", "H:mm"]).format(
            "HH:mm"
          ) +
          " - " +
          this.$dayjs(this.timeslot.endTime, ["h:mm:ss A", "H:mm"]).format(
            "HH:mm"
          )
        );
      }
      return this.$t("navbar.noTimeslot");
    },
    text() {
      return this.$t(
        "navbar.address." +
          this.shippingAddress.addressTypeId +
          ".timeslotButtonTitle"
      );
    }
  },
  methods: {
    edit() {
      if (this.editable) {
        this.$emit("edit");
      }
    }
  }
};
</script>
